import React, { FC, useMemo } from "react";
import { View } from "react-native";
import { NextBestActionDefinitionActionIcon } from "../../../../../../projection/nextBestActionDefinition/nextBestActionDefinition";
import { Brand } from "./Brand";
import { Camera } from "./Camera";
import { Color } from "./Color";
import { Measurements } from "./Measurements";
import { style } from "./NextBestActionCardIcon.style";
import { Price } from "./Price";

const IconForAction: Record<NextBestActionDefinitionActionIcon, FC> = {
  ["next_best_action.icon.brands"]: Brand,
  ["next_best_action.icon.photos"]: Camera,
  ["next_best_action.icon.colors_and_patterns"]: Color,
  ["next_best_action.icon.prices"]: Price,
  ["next_best_action.icon.measurements"]: Measurements,
};

interface NextBestActionCardIconProps {
  readonly icon: NextBestActionDefinitionActionIcon;
}

const NextBestActionCardIcon: FC<NextBestActionCardIconProps> = ({ icon }) => {
  const Icon = useMemo(() => IconForAction[icon], [icon]);

  return (
    <View style={style.icon} testID={icon}>
      {Icon ? <Icon /> : null}
    </View>
  );
};

export { NextBestActionCardIcon };
